import { render } from "./ExceptionForm.vue?vue&type=template&id=728c1c1a&scoped=true"
import script from "./ExceptionForm.vue?vue&type=script&lang=js"
export * from "./ExceptionForm.vue?vue&type=script&lang=js"

import "./ExceptionForm.vue?vue&type=style&index=0&id=728c1c1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728c1c1a"]])

export default __exports__